import { render, staticRenderFns } from "./TrunkCable.vue?vue&type=template&id=55cab4b6"
import script from "./TrunkCable.vue?vue&type=script&lang=js"
export * from "./TrunkCable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports